<template>
  <optional-link
    :disabled="!state.user.isAdmin"
    :to="{name: 'edit_organization'}"
    class="flex"
  >
    <img
      :src="state.organization.image.url"
      class="thumbnail"
    />

    <div class="mya pl2" v-if="state.organization.name">
      <h4 class="my0 medium">{{ state.organization.name }}</h4>
      <h5 class="my0">{{ state.organization.subtitle }}</h5>
    </div>
  </optional-link>
</template>

<script>
import store from '@/store';

export default {
  name: 'organization',

  data() {
    return {
      state: store.state,
    };
  },
};
</script>
